/* ANTINORM – Product Quiz  v9  |  assets/antinorm-quiz.js
   Taken exactly from the working version (document 4).
   Tracking added as a non-blocking side-effect only. */

(function () {
  'use strict';

  var QUESTIONS = [
    {
      id: 'skin', single: false,
      options: [
        { value: 'oily',         emoji: '💦',  label: 'Oily / shine' },
        { value: 'dry',          emoji: '🏜️', label: 'Dry / flaky' },
        { value: 'combo',        emoji: '🌗',  label: 'Combination' },
        { value: 'redness',      emoji: '🍓',  label: 'Redness' },
        { value: 'sensitive',    emoji: '🌡️', label: 'Sensitive' },
        { value: 'acne',         emoji: '🎯',  label: 'Acne / breakout' },
        { value: 'pigmentation', emoji: '🟤',  label: 'Pigmentation / dark spots' },
        { value: 'dull',         emoji: '😶',  label: 'Dull / tired' },
        { value: 'pores',        emoji: '🔍',  label: 'Open pores' },
        { value: 'dehydrated',   emoji: '💧',  label: 'Dehydrated (AC-dry)' },
        { value: 'tan',          emoji: '☀️',  label: 'Tan / damage' },
        { value: 'finelines',    emoji: '🕰️', label: 'Fine lines' },
        { value: 'ageing',       emoji: '👵',  label: 'Ageing' },
        { value: 'dark_circles', emoji: '👁️', label: 'Dark circles' },
      ]
    },
    {
      id: 'hair', single: false,
      options: [
        { value: 'oily_scalp',   emoji: '💦',  label: 'Oily scalp' },
        { value: 'frizzy',       emoji: '🌪️', label: 'Frizz / dryness' },
        { value: 'hairfall',     emoji: '🍂',  label: 'Hair fall' },
        { value: 'dandruff',     emoji: '❄️',  label: 'Dandruff / flaky' },
        { value: 'split_ends',   emoji: '✂️',  label: 'Split ends' },
        { value: 'coloured',     emoji: '🎨',  label: 'Colour-treated' },
        { value: 'straightened', emoji: '📏',  label: 'Chemically straight' },
        { value: 'limp',         emoji: '🪶',  label: 'Flat' },
        { value: 'hard_water',   emoji: '🪨',  label: 'Hard-water damage' },
        { value: 'greying',      emoji: '🩶',  label: 'Greying' },
        { value: 'breakage',     emoji: '💔',  label: 'Breakage' },
        { value: 'heat_styled',  emoji: '🔥',  label: 'Heat-styled' },
        { value: 'no_issue',     emoji: '👌',  label: 'None' },
      ]
    },
    {
      id: 'age', single: true,
      options: [
        { value: 'u25',    emoji: '🌱', label: 'Under 25' },
        { value: 'a25_34', emoji: '⚡', label: '25 – 34' },
        { value: 'a35_44', emoji: '🔥', label: '35 – 44' },
        { value: 'a45p',   emoji: '🌿', label: '45+' },
      ]
    },
    {
      id: 'lifestyle', single: false,
      options: [
        { value: 'go',      emoji: '🏃', label: 'Always on the go' },
        { value: 'wfh',     emoji: '🏠', label: 'Work from home' },
        { value: 'active',  emoji: '💪', label: 'Gym / Active' },
        { value: 'travel',  emoji: '✈️', label: 'Frequent traveller' },
        { value: 'social',  emoji: '🎉', label: 'Social & outgoing' },
        { value: 'outdoor', emoji: '☀️', label: 'Outdoors a lot' },
      ]
    }
  ];

  var BUILD_MSGS = [
    'Reading your skin profile…',
    'Analysing your hair concerns…',
    'Mapping your lifestyle…',
    'Matching you to your routine…',
    'Personalising your results…',
    'Almost there…'
  ];

  var PERSONAS = {
    'oily|u25|go':       { name:'Riya',      job:'college student',             city:'Delhi',      climate:'humid monsoon months',            icon:'🌤️' },
    'oily|u25|social':   { name:'Aanya',     job:'fashion intern',              city:'Mumbai',     climate:'coastal humidity',                icon:'🌊' },
    'oily|u25|wfh':      { name:'Diya',      job:'freelance graphic designer',  city:'Hyderabad',  climate:'warm, sticky summers',            icon:'🎨' },
    'oily|u25|active':   { name:'Simran',    job:'college athlete',             city:'Chandigarh', climate:'hot and sweaty summers',          icon:'🏅' },
    'oily|a25_34|go':    { name:'Priya',     job:'startup founder',             city:'Bengaluru',  climate:'year-round humidity',             icon:'🚀' },
    'oily|a25_34|active':{ name:'Meghna',    job:'fitness trainer',             city:'Pune',       climate:'heat and sweat',                  icon:'💪' },
    'oily|a25_34|social':{ name:'Kaveri',    job:'event manager',               city:'Mumbai',     climate:'coastal air and long nights',     icon:'🎤' },
    'oily|a25_34|wfh':   { name:'Shreya',    job:'UX designer',                 city:'Chennai',    climate:'intense southern heat',           icon:'💻' },
    'oily|a25_34|travel':{ name:'Neha',      job:'travel journalist',           city:'Mumbai',     climate:'airports and new cities',         icon:'✈️' },
    'oily|a35_44|go':    { name:'Nalini',    job:'senior marketing manager',    city:'Bengaluru',  climate:'humidity and pollution',          icon:'📱' },
    'oily|a35_44|wfh':   { name:'Pooja',     job:'architect',                   city:'Hyderabad',  climate:'dry heat and AC air',             icon:'🏛️' },
    'oily|a35_44|active':{ name:'Rekha',     job:'yoga instructor',             city:'Pune',       climate:'outdoor morning sessions',        icon:'🧘' },
    'oily|a45p|go':      { name:'Sudha',     job:'hospital administrator',      city:'Chennai',    climate:'year-round tropical heat',        icon:'🏥' },
    'oily|a45p|wfh':     { name:'Radha',     job:'senior therapist',            city:'Bengaluru',  climate:'year-round humidity',             icon:'🌿' },
    'dry|u25|wfh':       { name:'Isha',      job:'literature student',          city:'Shimla',     climate:'cold, dry mountain air',          icon:'📚' },
    'dry|u25|social':    { name:'Tara',      job:'theatre artist',              city:'Jaipur',     climate:'desert dryness',                  icon:'🎭' },
    'dry|u25|outdoor':   { name:'Kriti',     job:'photography student',         city:'Rishikesh',  climate:'dry mountain winds',              icon:'📷' },
    'dry|a25_34|go':     { name:'Ananya',    job:'journalist',                  city:'New Delhi',  climate:'harsh winters and AC offices',    icon:'📰' },
    'dry|a25_34|travel': { name:'Ruchika',   job:'travel writer',               city:'Goa',        climate:'sea breeze and sun',              icon:'🌴' },
    'dry|a25_34|wfh':    { name:'Nandita',   job:'content strategist',          city:'Kolkata',    climate:'winters and AC-heavy work',       icon:'✍️' },
    'dry|a25_34|social': { name:'Aparna',    job:'public relations executive',  city:'Delhi',      climate:'pollution and dry winters',       icon:'🌟' },
    'dry|a35_44|go':     { name:'Kavitha',   job:'paediatrician',               city:'Ahmedabad',  climate:'dry Gujarati heat',               icon:'👩‍⚕️' },
    'dry|a35_44|wfh':    { name:'Smita',     job:'financial analyst',           city:'Pune',       climate:'cold winters and dry spells',     icon:'📊' },
    'dry|a35_44|social': { name:'Leela',     job:'luxury hotel manager',        city:'Mumbai',     climate:'coastal humidity and AC',         icon:'🏨' },
    'dry|a45p|wfh':      { name:'Usha',      job:'university professor',        city:'Chandigarh', climate:'cold winters and dry air',        icon:'🎓' },
    'dry|a45p|go':       { name:'Kamala',    job:'district judge',              city:'Jaipur',     climate:'arid Rajasthani climate',         icon:'⚖️' },
    'dry|a45p|social':   { name:'Vandana',   job:'gallery curator',             city:'Delhi',      climate:'harsh summers and pollution',     icon:'🖼️' },
    'dull|u25|outdoor':  { name:'Meenakshi', job:'environmental science student',city:'Coimbatore',climate:'outdoor fieldwork in heat',       icon:'🌱' },
    'dull|u25|active':   { name:'Srishti',   job:'running enthusiast',          city:'Bengaluru',  climate:'outdoor training in humidity',    icon:'🏃' },
    'dull|a25_34|go':    { name:'Divya',     job:'sales manager',               city:'Hyderabad',  climate:'long commutes in the sun',        icon:'🚗' },
    'dull|a25_34|active':{ name:'Suhana',    job:'running coach',               city:'Mumbai',     climate:'coastal sun and salt air',        icon:'🏅' },
    'dull|a25_34|outdoor':{ name:'Bhavna',   job:'landscape architect',         city:'Ahmedabad',  climate:'scorching outdoor sites',         icon:'🌻' },
    'dull|a25_34|travel':{ name:'Preethi',   job:'aviation professional',       city:'Chennai',    climate:'airports and constant travel',    icon:'✈️' },
    'dull|a35_44|go':    { name:'Madhuri',   job:'real estate developer',       city:'Bengaluru',  climate:'sun-heavy site visits',           icon:'🏗️' },
    'dull|a35_44|active':{ name:'Sunita',    job:'marathon runner',             city:'Mumbai',     climate:'coastal heat and humidity',       icon:'🏃' },
    'dull|a45p|go':      { name:'Sarla',     job:'NGO director',                city:'Bhopal',     climate:'field work in scorching heat',    icon:'🌍' },
    'ageing|a35_44|wfh': { name:'Prerna',    job:'novelist',                    city:'Dehradun',   climate:'cool hills with dry air',         icon:'📖' },
    'ageing|a35_44|go':  { name:'Karuna',    job:'successful doctor',           city:'Bengaluru',  climate:'humid climate',                   icon:'👩‍⚕️' },
    'ageing|a35_44|social':{ name:'Leela',   job:'luxury hotel director',       city:'Mumbai',     climate:'coastal humidity and fine dining', icon:'🍷' },
    'ageing|a35_44|travel':{ name:'Shalini', job:'investment banker',           city:'Mumbai',     climate:'constant flights and cold air',   icon:'💼' },
    'ageing|a45p|wfh':   { name:'Shobha',    job:'senior therapist',            city:'Kolkata',    climate:'humid Bengal weather',            icon:'🧠' },
    'ageing|a45p|go':    { name:'Geeta',     job:'IAS officer',                 city:'Lucknow',    climate:'extreme seasonal swings',         icon:'🏛️' },
    'ageing|a45p|social':{ name:'Vandana',   job:'gallery curator',             city:'Delhi',      climate:'harsh summers and pollution',     icon:'🎨' },
    'ageing|a45p|travel':{ name:'Laxmi',     job:'senior consultant',           city:'Bengaluru',  climate:'airport lounges and boardrooms',  icon:'✈️' },
    'sensitive|u25|wfh': { name:'Aishwarya', job:'medical student',             city:'Vellore',    climate:'hot and humid south',             icon:'💊' },
    'sensitive|a25_34|go':{ name:'Pallavi',  job:'HR professional',             city:'Gurugram',   climate:'pollution and AC extremes',       icon:'👩‍💼' },
    'sensitive|a25_34|wfh':{ name:'Sonali',  job:'product manager',             city:'Bengaluru',  climate:'pollen season and AC offices',    icon:'💻' },
    'sensitive|a35_44|wfh':{ name:'Neerja',  job:'child psychologist',          city:'Pune',       climate:'seasonal dryness and pollen',     icon:'🌸' },
    'sensitive|a35_44|go':{ name:'Deepika',  job:'dermatologist',               city:'Bengaluru',  climate:'humidity and pollution',          icon:'👩‍⚕️' },
    'sensitive|a45p|wfh':{ name:'Meera',     job:'retired school principal',    city:'Mysuru',     climate:'mild but reactive to season change',icon:'🌼' },
    'dehydrated|a25_34|go':{ name:'Radhika', job:'corporate lawyer',            city:'Mumbai',     climate:'relentless AC and city air',      icon:'⚖️' },
    'dehydrated|a25_34|wfh':{ name:'Tanvi',  job:'data scientist',              city:'Hyderabad',  climate:'12-hour screen days',             icon:'📊' },
    'dehydrated|a35_44|go':{ name:'Shalini', job:'investment banker',           city:'Delhi',      climate:'constant flights and cold air',   icon:'💼' },
    'dehydrated|a35_44|wfh':{ name:'Sunanda',job:'novelist and editor',         city:'Bengaluru',  climate:'long desk hours and AC',          icon:'📝' },
    'dehydrated|a45p|go':{ name:'Laxmi',     job:'senior consultant',           city:'Bengaluru',  climate:'airport lounges and boardrooms',  icon:'✈️' },
    'default|u25|any':   { name:'Nitya',     job:'college student',             city:'Mumbai',     climate:'coastal city humidity',           icon:'🌊' },
    'default|a25_34|any':{ name:'Zara',      job:'marketing professional',      city:'Bengaluru',  climate:'year-round humidity',             icon:'🌿' },
    'default|a35_44|any':{ name:'Karuna',    job:'doctor',                      city:'Bengaluru',  climate:'humid climate',                   icon:'👩‍⚕️' },
    'default|a45p|any':  { name:'Sudha',     job:'senior professional',         city:'Chennai',    climate:'tropical heat',                   icon:'🌺' },
  };

  function resolvePersona(ans) {
    var skinPriority = ['ageing','dehydrated','sensitive','dull','acne','oily','dry','combo'];
    var skinBucket = 'default';
    for (var si = 0; si < skinPriority.length; si++) {
      if (ans.skin.indexOf(skinPriority[si]) > -1) { skinBucket = skinPriority[si]; break; }
    }
    if (skinBucket === 'combo') skinBucket = 'oily';
    var ageBucket = (ans.age && ans.age[0]) || 'a25_34';
    var lifePriority = ['travel','active','outdoor','social','go','wfh'];
    var lifeBucket = 'any';
    for (var li = 0; li < lifePriority.length; li++) {
      if (ans.lifestyle.indexOf(lifePriority[li]) > -1) { lifeBucket = lifePriority[li]; break; }
    }
    var ageTiers = ['a25_34','a35_44','u25','a45p'];
    for (var ai = 0; ai < ageTiers.length; ai++) {
      var k1 = skinBucket + '|' + ageTiers[ai] + '|' + lifeBucket;
      var k2 = skinBucket + '|' + ageTiers[ai] + '|any';
      if (PERSONAS[k1]) return PERSONAS[k1];
      if (PERSONAS[k2]) return PERSONAS[k2];
    }
    return PERSONAS['default|' + ageBucket + '|any'] ||
           { name:'Priya', job:'professional', city:'Bengaluru', climate:'humid climate', icon:'🌿' };
  }

  var WEIGHTS = { skin: 3, hair: 2, age: 1, lifestyle: 1 };
  var answers = { skin: [], hair: [], age: [], lifestyle: [] };
  var currentResults = [];

  function $i(id) { return document.getElementById(id); }

  function setProgress(step) {
    var fill  = $i('anq-prog-fill');
    var label = $i('anq-prog-label');
    var pct   = Math.min(step, 4) / 4 * 100;
    if (fill)  fill.style.width = pct + '%';
    if (label) label.textContent = (step >= 1 && step <= 4) ? 'Step ' + step + ' of 4' : '';
  }

  function showScreen(id) {
    document.querySelectorAll('.anq-screen').forEach(function (s) { s.classList.remove('active'); });
    var t = $i(id);
    if (!t) return;
    t.style.animation = 'none';
    void t.offsetWidth;
    t.style.animation = '';
    t.classList.add('active');
    var section = document.getElementById('antinorm-quiz-section');
    if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function buildBubbles() {
    QUESTIONS.forEach(function (q, qi) {
      var wrap = $i('anq-bubbles-q' + qi);
      if (!wrap) return;
      wrap.innerHTML = '';
      q.options.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.className = 'bubble';
        btn.dataset.value = opt.value;
        btn.innerHTML =
          '<span class="bubble-em">' + opt.emoji + '</span>' +
          '<span>' + opt.label + '</span>';
        btn.addEventListener('click', function () { toggle(qi, opt.value, btn); });
        wrap.appendChild(btn);
      });
    });
  }

  function toggle(qi, value, btn) {
    var qId = QUESTIONS[qi].id;
    if (QUESTIONS[qi].single) {
      document.querySelectorAll('#anq-bubbles-q' + qi + ' .bubble').forEach(function (b) {
        b.classList.remove('selected');
      });
      answers[qId] = [];
    }
    var idx = answers[qId].indexOf(value);
    if (idx > -1) {
      answers[qId].splice(idx, 1);
      btn.classList.remove('selected');
    } else {
      answers[qId].push(value);
      btn.classList.add('selected');
    }
    var nb = $i('anq-next-q' + qi);
    if (nb) nb.classList.toggle('enabled', answers[qId].length > 0);
  }

  window.anqShowQuestion = function (qi) {
    if (qi === 0 && window.ANQ_TRACK) { try { window.ANQ_TRACK.quizStarted(); } catch(e){} }
    showScreen('anq-screen-q' + qi);
    setProgress(qi + 1);
  };

  window.anqAdvance = function (qi) {
    if (!answers[QUESTIONS[qi].id].length) return;
    if (window.ANQ_TRACK) { try { window.ANQ_TRACK.questionAnswered(QUESTIONS[qi].id, answers[QUESTIONS[qi].id].slice()); } catch(e){} }
    if (qi < QUESTIONS.length - 1) window.anqShowQuestion(qi + 1);
    else window.anqRunBuild();
  };

  window.anqGoBack = function (qi) {
    if (qi === 0) { showScreen('anq-screen-intro'); setProgress(0); }
    else window.anqShowQuestion(qi - 1);
  };

  function scoreProduct(p) {
    var total = 0, max = 0;
    QUESTIONS.forEach(function (q) {
      var sel = answers[q.id];
      var w   = WEIGHTS[q.id] || 1;
      var ps  = (p.scores && p.scores[q.id]) || {};
      sel.forEach(function (val) { total += (ps[val] || 0) * w; });
      max += 5 * w * (sel.length || 1);
    });
    return max > 0 ? Math.round((total / max) * 100) : 0;
  }

  window.anqRunBuild = function () {
    var lastQ = QUESTIONS[QUESTIONS.length - 1];
    if (!answers[lastQ.id].length) return;
    if (window.ANQ_TRACK) { try { window.ANQ_TRACK.questionAnswered(lastQ.id, answers[lastQ.id].slice()); } catch(e){} }
    showScreen('anq-screen-building');
    setProgress(5);

    var i = 0;
    var msgEl = $i('anq-build-msg');
    if (msgEl) msgEl.textContent = BUILD_MSGS[0];
    var iv = setInterval(function () {
      i = (i + 1) % BUILD_MSGS.length;
      if (msgEl) msgEl.textContent = BUILD_MSGS[i];
    }, 480);

    setTimeout(function () {
      clearInterval(iv);

      /* Score first — pure JS, no DOM */
      var prods = window.ANQ_PRODUCTS || [];
      var scored = prods.map(function (p) {
        return Object.assign({}, p, { matchPct: scoreProduct(p) });
      });
      scored.sort(function (a, b) { return b.matchPct - a.matchPct; });
      currentResults = scored.filter(function (p) { return p.matchPct > 0; }).slice(0, 3);
      if (!currentResults.length) currentResults = scored.slice(0, 3);

      /* Fire tracking BEFORE any DOM work */
      if (window.ANQ_TRACK) {
        try {
          var persona = resolvePersona(answers);
          window.ANQ_TRACK.quizCompleted(answers, persona.name, currentResults);
        } catch (e) { console.error('[ANQ] tracking error:', e); }
      }

      /* Render cards — isolated in try-catch so theme errors can't block tracking */
      try { renderResults(); } catch (e) { console.error('[ANQ] render error:', e); }

      showScreen('anq-screen-results');
    }, 2400);
  };

  function addUtm(url, handle) {
    var base   = url.split('?')[0];
    var params = 'utm_source=antinorm_quiz&utm_medium=quiz_widget&utm_campaign=routine_builder';
    if (handle) params += '&utm_content=' + encodeURIComponent(handle);
    return base + '?' + params;
  }

  function renderResults() {
    var persona = resolvePersona(answers);

    var personaLine = $i('anq-persona-line');
    var personaIcon = $i('anq-persona-icon');
    if (personaLine) {
      personaLine.textContent = 'You represent ' + persona.name +
        ', who is a ' + persona.job + ' based out of ' + persona.city +
        ' — dealing with ' + persona.climate + '.';
    }
    if (personaIcon) personaIcon.textContent = persona.icon;

    var forEl = $i('anq-fortags');
    if (forEl) {
      var skinLabels = answers.skin.slice(0, 3).map(function (v) { return v.replace(/_/g, ' '); });
      var hairLabels = answers.hair.slice(0, 2).map(function (v) { return v.replace(/_/g, ' '); });
      var all = skinLabels.concat(hairLabels);
      forEl.textContent = 'Built for: ' + (all.length ? all.join(' · ') : 'you');
    }

    var grid = $i('anq-products-grid');
    if (!grid) return;
    grid.innerHTML = '';
    if (!currentResults.length) {
      grid.innerHTML = '<p style="color:#888884;font-size:14px;grid-column:1/-1">No matches — <a href="/collections/all" style="color:#C97B3A">browse all products</a>.</p>';
      return;
    }

    var totalValue = 0;
    currentResults.forEach(function (p, idx) {
      var priceNum = parseFloat((p.price || '0').replace(/[^0-9.]/g, '')) || 0;
      totalValue += priceNum;

      var card = document.createElement('div');
      card.className = 'product-card';
      var imgHtml = p.image ? '<img src="' + p.image + '" alt="' + p.name + '" loading="lazy">' : '';
      var why = (p.desc || '').split('.')[0] + '.';

      card.innerHTML =
        '<div class="score-bar"><div class="score-fill" data-pct="' + p.matchPct + '" style="width:0%"></div></div>' +
        '<div class="product-img">' + imgHtml + '</div>' +
        '<div class="product-body">' +
          '<div class="product-meta"><span class="product-cat">' + p.type + '</span></div>' +
          '<div class="product-name-row">' +
            '<div class="product-name">' + (idx + 1) + '. ' + p.name + '</div>' +
            '<div class="product-price">' + p.price + '</div>' +
          '</div>' +
          '<div class="product-desc">' + p.desc + '</div>' +
          '<div class="product-why">' + why + '</div>' +
          '<div class="card-btns">' +
            '<a class="btn-view" href="' + addUtm(p.url, p.handle) + '"' +
              ' onclick="anqTrackView(' + JSON.stringify({ handle: p.handle || '', name: p.name, url: p.url }) + ')"' +
              '>View</a>' +
            '<button class="btn-cart-plus"' +
              ' data-handle="' + (p.handle || '') + '"' +
              ' data-name="' + p.name.replace(/"/g, '&quot;') + '"' +
              ' onclick="anqAddToCart(this)"' +
              ' title="Add ' + p.name.replace(/"/g, '&quot;') + ' to cart"' +
              '>+</button>' +
          '</div>' +
        '</div>';
      grid.appendChild(card);
    });

    var totalEl = $i('anq-total');
    if (totalEl) totalEl.textContent = '₹' + totalValue.toLocaleString('en-IN');

    requestAnimationFrame(function () {
      grid.querySelectorAll('.score-fill').forEach(function (el) {
        setTimeout(function () { el.style.width = el.dataset.pct + '%'; }, 250);
      });
    });
  }

  function showToast(msg) {
    var t = $i('anq-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 2700);
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count,.cart__count,.header__cart-count')
          .forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
  }

  /* ── variant resolver: fetch first available variant ID from product handle ── */
  var _variantCache = {};
  function resolveVariantId(handle) {
    if (_variantCache[handle]) return Promise.resolve(_variantCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found: ' + handle);
        return r.json();
      })
      .then(function (data) {
        var variants = data.variants || [];
        var available = variants.filter(function (v) { return v.available; });
        var chosen = (available.length ? available[0] : variants[0]);
        if (!chosen) throw new Error('No variants found for: ' + handle);
        var vid = String(chosen.id);
        _variantCache[handle] = vid;
        return vid;
      });
  }

  window.anqAddToCart = function (btn) {
    var handle = btn.dataset.handle;
    var name   = btn.dataset.name || 'Product';
    if (!handle) { showToast('Product handle missing'); return; }
    var trackProduct = (window.ANQ_PRODUCTS || []).filter(function (p) { return p.handle === handle; })[0] || { name: name, handle: handle };
    if (window.ANQ_TRACK) { try { window.ANQ_TRACK.addToCart(trackProduct); } catch(e){} }
    btn.disabled = true;
    btn.textContent = '…';
    resolveVariantId(handle)
      .then(function (vid) {
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body:    JSON.stringify({ id: vid, quantity: 1 })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'HTTP ' + r.status); });
        return r.json();
      })
      .then(function () {
        btn.classList.add('added');
        btn.textContent = '✓';
        showToast(name + ' added to cart');
        refreshCart();
      })
      .catch(function (e) {
        btn.disabled = false;
        btn.textContent = '+';
        showToast('Could not add: ' + e.message);
      });
  };

  window.anqTrackView = function (product) {
    if (window.ANQ_TRACK) { try { window.ANQ_TRACK.viewProduct(product); } catch(e){} }
  };

  window.anqAddAllToCart = function () {
    var btn = $i('anq-add-all');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var toAdd = currentResults.filter(function (p) { return p.handle; });
    if (!toAdd.length) { showToast('Nothing to add'); if (btn) btn.disabled = false; return; }
    if (window.ANQ_TRACK) {
      try {
        var totalVal = toAdd.reduce(function (s, p) { return s + (parseFloat((p.price || '0').replace(/[^0-9.]/g, '')) || 0); }, 0);
        window.ANQ_TRACK.addAllToCart(toAdd, totalVal);
      } catch(e) {}
    }
    /* Resolve all variant IDs first, then bulk-add */
    Promise.all(toAdd.map(function (p) { return resolveVariantId(p.handle); }))
      .then(function (vids) {
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body:    JSON.stringify({ items: vids.map(function (v) { return { id: v, quantity: 1 }; }) })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'HTTP ' + r.status); });
        return r.json();
      })
      .then(function () {
        document.querySelectorAll('.btn-cart-plus').forEach(function (b) {
          b.classList.add('added'); b.textContent = '✓'; b.disabled = true;
        });
        showToast('All ' + toAdd.length + ' products added!');
        refreshCart();
        setTimeout(function () {
          window.location.href = '/cart?utm_source=antinorm_quiz&utm_medium=quiz_widget&utm_campaign=routine_builder&utm_content=add_all';
        }, 800);
      })
      .catch(function (e) {
        showToast('Could not add all: ' + e.message);
        if (btn) { btn.disabled = false; btn.textContent = 'Add All to Cart →'; }
      });
  };

  window.anqRestart = function () {
    if (window.ANQ_TRACK) { try { window.ANQ_TRACK.quizRestarted(); } catch(e){} }
    answers = { skin: [], hair: [], age: [], lifestyle: [] };
    currentResults = [];
    document.querySelectorAll('.bubble').forEach(function (b) { b.classList.remove('selected'); });
    document.querySelectorAll('.btn-next').forEach(function (b) { b.classList.remove('enabled'); });
    showScreen('anq-screen-intro');
    setProgress(0);
  };

  document.addEventListener('DOMContentLoaded', buildBubbles);
  document.addEventListener('shopify:section:load', buildBubbles);

})();
